import { InputText, Button, Checkbox } from "primereact";
import MultiLanguageEditor from "../MultiLanguageEditor";
import { useLanguages } from "../../hooks/use-languages";
import { useParams, useHistory } from "react-router-dom/cjs/react-router-dom";
import { getCommonParam } from "../../config";
import { useEffect } from "react";
import axios from "axios";
import QrcodeProduct from "../QrcodeProduct";
import { useForm, Controller } from "react-hook-form";
import { useToast } from "../../hooks/use-toast";
import { getMultiLngInitValue, initValue, validateMultiLanguageEditor } from "../../util";
import ShowOrUploadImg from "../ShowOrUploadImg";

const Details = ({ product }) => {
  const { languages } = useLanguages();
  const { id, tipo } = useParams();
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { isSubmitting, isDirty },
  } = useForm();
  const { toastRef } = useToast();
  const history = useHistory();

  const save = async (data) => {
    try {
   
      const apiCommonParam = getCommonParam();
      const { apiUrl, axiosConfig, user } = apiCommonParam;
      let endpoint = "";
      data.status = product.status || " ";
      if (tipo === "U") {
        endpoint = `prodotto/salva/${id}`;
      }
      if (tipo === "I") {
        data.aziendaid = user.aziendaid;
        endpoint = `prodotto/aggiungi`;
      }
      if (tipo === "D") {
        data.status = "E";
        endpoint = `prodotto/salva/${id}`;
      }
      await axios.post(`${apiUrl}${endpoint}`, data, axiosConfig);
      toastRef.current.showToast("success", "Dati salvati correttamente", "");
      if (tipo === "U") window.location.reload();
      else history.push("/listaProdotti");
    } catch (error) {
      console.error(error);
      toastRef.current.showToast("error", error, "");
    }
  };

  useEffect(() => {
    if (id !== 0 && !!product && product.length !== 0) {
      const init = initValue(product);
      reset({ ...init, codiceprodotto: product.codiceprodotto, visible:product.visible });
    }
  }, [product]);

  const onSubmit = async (data) => {
    await save({ codiceprodotto: data.codiceprodotto, visible:data.visible,traduzione: [...data.nome, ...data.descrizione] });
  };

  if (id > 0 && (!product || product.lenght === 0)) return null;

  return (
    <div className="flex w-full flex-column ">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-row w-full align-items-center  gap-5  mb-2">
          <div className="flex flex-column w-full px-2 mb-4">
            <label htmlFor="codiceprodotto" className="font-medium text-600">
              Codice Prodotto
            </label>
            <Controller
              name="codiceprodotto"
              control={control}
              defaultValue={""}
              rules={{ required: "Campo obbligatorio" }}
              render={({ field, fieldState }) => (
                <>
                  <InputText
                    {...field}
                    className="w-full flex"
                    type="text"
                    readOnly={tipo === "V" || tipo === "D" ? true : false}
                  />
                  {fieldState && fieldState?.error && (
                    <span className="text-xs font-bold text-red-500 ">{fieldState.error.message}</span>
                  )}
                </>
              )}
            />
          </div>
          <div className="flex flex-column w-full px-2 mb-4">
            <label htmlFor="visible" className="font-medium text-600">
              Visibile in Vetrina
            </label>
            <Controller
              name="visible"
              control={control}
              defaultValue={""}
              render={({ field, fieldState }) => (
                <>
               
                  <Checkbox
                    {...field}
                    className="w-full flex"
                    checked={field.value}
                  />
                 
                </>
              )}
            />
          </div>
         

          {!!id && id > 0 && (
            <div className="flex w-full align-items-center justify-content-center ">
              <QrcodeProduct id={id} />
            </div>
          )}
        </div>

        <Controller
          name="nome"
          control={control}
          rules={{ validate: (values) => validateMultiLanguageEditor(values, languages) }}
          render={({ field, fieldState }) => (
            <>
              <MultiLanguageEditor
                label={"Nome"}
                languages={languages}
                className={"px-2"}
                content={getMultiLngInitValue("prodotto", "nome", languages, field.value)}
                isReadOnly={tipo === "V" || tipo === "D" ? true : false}
                setValue={setValue}
                fieldName={"nome"}
                error={fieldState.error ?? undefined}
              />
            </>
          )}
        />

        <Controller
          name="descrizione"
          control={control}
          rules={{ validate: (values) => validateMultiLanguageEditor(values, languages) }}
          render={({ field, fieldState }) => (
            <>
              <MultiLanguageEditor
                label={"Descrizione"}
                type="text-area"
                languages={languages}
                className={"px-2"}
                content={getMultiLngInitValue("prodotto", "descrizione", languages, field.value)}
                isReadOnly={tipo === "V" || tipo === "D" ? true : false}
                setValue={setValue}
                fieldName={"descrizione"}
                error={fieldState.error ?? undefined}
              />
            </>
          )}
        />

        <div className="flex flex-column gap-2  px-3   ">
          <ShowOrUploadImg
            hasImage={product && product.hasImage}
            operationType={tipo}
            itemId={id}
            aziendaid={product.aziendaid}
            label={"Aggiungi immagine prodotto"}
            isDirty={isDirty}
            table="prodotto"
          />
        </div>
        <div className="flex flex-row gap-2 mt-4">
          {(tipo === "U" || tipo === "I") && (
            <Button
              label="Salva"
              className="ml-3 p-button-outlined font-bold pi"
              type="submit"
              icon="pi pi-save"
              loading={isSubmitting}
              disabled={isSubmitting}
            />
          )}
          {tipo === "U" && (
            <Button
              type="button"
              onClick={() => {
                initValue(product);
              }}
              label="Annulla"
              className="ml-3 p-button-outlined font-bold pi"
              icon="pi pi-times"
              disabled={isSubmitting}
            />
          )}
          {tipo === "D" && (
            <Button
              label="Elimina"
              className="ml-3 p-button-outlined p-button-danger"
              type="submit"
              icon="pi pi-trash"
              disabled={isSubmitting}
              loading={isSubmitting}
            />
          )}

          <Button
            label="Indietro"
            className="ml-3 p-button-outlined "
            type="button"
            onClick={() => history.push("/listaProdotti")}
            icon="pi pi-step-backward-alt"
            disabled={isSubmitting}
          />
        </div>
      </form>
    </div>
  );
};

export default Details;
